import { useState } from 'react';

import { Confirm } from '../confirm/confirm';
import { Content, Fields, Block } from './confirm-comment.styled';

export const ConfirmComment = (props) => {
  const [comment, setComment] = useState('');
  const [reason, setReason] = useState('');
  if (!window.dict['reasonofpass']) {
    return null;
  }

  /**
   * set value from input
   * @param {*} event
   */
  const setValue = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    if (name === 'reason') {
      setReason(value);
    }
    if (name === 'comment') {
      setComment(value);
    }
  };

  /**
   * send message
   */
  const action = () => {
    const out = 'Причина: ' + reason + '. Комментарий: ' + comment;
    props.action(out);
    props.close();
  };

  /**
   * validation
   */
  const isValid = () => {
    return reason && comment.trim().length > 0;
  };

  const valid = isValid();
  const dict = window.dict['reasonofpass'];
  const items = dict.map((el, idx) => {
    return (
      <option key={idx} value={el.name}>
        {el.name}
      </option>
    );
  });

  const objectTitle = props.objectTitle ?? 'шлагбаум';

  return (
    <Confirm close={props.close} title={'Открыть ' + objectTitle} action={action} actionTitle="Подтвердить" actionDisabled={!valid} arrowPos={props.arrowPos} topPos={props.topPos} above={props.above}>
      <Content>
        <p>Выберите причину открытия и заполните поле комментарий</p>
        <Fields>
          {items.length > 0 && (
            <Block>
              <label htmlFor="reason">Причина</label>
              <select id="reason" value={reason} name="reason" onChange={setValue}>
                <option value={''}></option>
                {items}
              </select>
            </Block>
          )}
          <Block>
            <label htmlFor="comment">Комментарий</label>
            <input maxLength={255} type="text" id="comment" name="comment" value={comment} onChange={setValue} />
          </Block>
        </Fields>
      </Content>
    </Confirm>
  );
};
